import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Cliente } from "../../../../services/Cliente";

export const useConcessionariasLista = () => {
  const query = useQuery({
    queryKey: ["concessionarias-lista"],
    queryFn: () => Cliente.getConcessionarias(),
    select: (response) => response.data.content,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
